export * from './xyz.component';
export * from './osmmaps.component';
export * from './vector.component';
